import { RootState } from 'store';

const LocationsState = (state: RootState) => state.appointments.locations;
export const selectLocations = (state: RootState) => LocationsState(state).rows;
export const selectLocationsLoading = (state: RootState) => LocationsState(state).loading;
export const selectLocationDistance = (state: RootState) => LocationsState(state).distance;
export const selectErrorResponse = (state: RootState) => LocationsState(state).error;
